import {
  Bird, Fish, Rabbit, Squirrel, Turtle, Snail, Leaf, TreePine, Flower, Flower2, Mountain, Waves, Sun, Moon, Star, Cloud,
  Snowflake, Feather, Shell, Sprout, Trees, Sailboat, Anchor, Tent, Compass, Sunrise, Wind, Droplets, Flame, Gem, Clover,
  Wheat, Sunset, MountainSnow, Footprints, Lamp, Route, PawPrint, Origami, Egg, Cherry, Rainbow,
} from "lucide-react";

const NOUN_ICON = {
  otter: PawPrint, trail: Footprints, heron: Bird, fox: PawPrint, river: Waves, lantern: Lamp, sparrow: Bird, harbor: Anchor,
  pine: TreePine, comet: Star, finch: Bird, brook: Droplets, wren: Feather, marsh: Sprout, orchard: Cherry, falcon: Bird,
  dune: Sunset, lotus: Flower2, badger: PawPrint, ridge: Mountain, robin: Egg, canyon: MountainSnow, puffin: Fish, glacier: Snowflake,
  willow: Trees, pebble: Gem, thistle: Flower, kestrel: Feather, cove: Sailboat, aspen: Leaf,
};
const ADJ_COLOR = {
  quiet: "bg-slate-200 text-slate-800", amber: "bg-amber-200 text-amber-900", gentle: "bg-rose-100 text-rose-800", bright: "bg-yellow-200 text-yellow-900",
  wandering: "bg-teal-200 text-teal-900", steady: "bg-stone-300 text-stone-800", golden: "bg-yellow-300 text-yellow-900", misty: "bg-sky-100 text-sky-800",
  coral: "bg-orange-200 text-orange-900", silver: "bg-slate-300 text-slate-900", sunny: "bg-amber-300 text-amber-900", mossy: "bg-lime-200 text-lime-900",
  brave: "bg-red-200 text-red-900", calm: "bg-cyan-100 text-cyan-800", cobalt: "bg-blue-200 text-blue-900", rosy: "bg-pink-200 text-pink-900",
  velvet: "bg-purple-200 text-purple-900", maple: "bg-orange-300 text-orange-950", cedar: "bg-amber-700 text-amber-50", dusky: "bg-indigo-200 text-indigo-900",
  ember: "bg-orange-400 text-orange-950", juniper: "bg-emerald-200 text-emerald-900", lunar: "bg-indigo-100 text-indigo-800", saffron: "bg-yellow-400 text-yellow-950",
  tidal: "bg-blue-100 text-blue-800", indigo: "bg-indigo-300 text-indigo-950", fern: "bg-green-200 text-green-900", hazel: "bg-amber-100 text-amber-900",
  copper: "bg-orange-200 text-orange-950", meadow: "bg-lime-100 text-lime-900",
};
const FALLBACK_ICONS = [Leaf, Bird, Sun, Moon, Cloud, Compass, Wind, Flame, Clover, Wheat, Sunrise, Tent, Route, Origami, Rainbow, Turtle, Rabbit, Squirrel, Snail, Shell, Sprout, Gem];
const FALLBACK_COLORS = ["bg-amber-200 text-amber-900", "bg-emerald-200 text-emerald-900", "bg-sky-200 text-sky-900", "bg-rose-200 text-rose-900", "bg-teal-200 text-teal-900", "bg-orange-200 text-orange-900", "bg-indigo-200 text-indigo-900", "bg-lime-200 text-lime-900"];

function hash(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

export function avatarFor(handle = "") {
  const words = handle.toLowerCase().split(/\s+/).filter(Boolean);
  const h = hash(handle.toLowerCase());
  const Icon = words.map((w) => NOUN_ICON[w]).find(Boolean) || FALLBACK_ICONS[h % FALLBACK_ICONS.length];
  const color = words.map((w) => ADJ_COLOR[w]).find(Boolean) || FALLBACK_COLORS[(h >> 4) % FALLBACK_COLORS.length];
  return { Icon, color };
}

const SIZES = { sm: "w-7 h-7 [&>svg]:w-3.5 [&>svg]:h-3.5", md: "w-10 h-10 [&>svg]:w-5 [&>svg]:h-5", lg: "w-14 h-14 [&>svg]:w-7 [&>svg]:h-7" };

export function HandleAvatar({ handle, size = "md", className = "" }) {
  const { Icon, color } = avatarFor(handle);
  return (
    <div data-testid="handle-avatar" title={handle} aria-label={handle}
      className={`${SIZES[size]} ${color} rounded-full flex items-center justify-center shrink-0 ring-2 ring-white shadow-sm ${className}`}>
      <Icon strokeWidth={2.25} />
    </div>
  );
}
